export default "__VITE_ASSET__C_f79WiF__"